var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-container"},[_c('v-alert',{attrs:{"border":"bottom","colored-border":"","elevation":"2","color":"#ea7f1d"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }